import React from 'react';
import pluralize from 'utils/pluralize';

const withoutParticipants = (type: string) => {
  return (
    <>
    <p>Учителя вашего {type} пока не участвовали в соревновании.</p>
    <p>Пригласите их, чтобы они могли получить награды в декабре</p>
    </>
  )
}

const withParticipants = ({count, type}: {count: number, type: string}) => {
  const countTeacher = `${count} ${pluralize(count || 0, [`учитель вашего ${type} может`, `учителя вашего ${type} могут`, `учителей вашего ${type} могут`])} получить награду в декабре.`;
  
  return (
    <>
    <p>{countTeacher}</p>
    <p>Проинформируйте о финальном этапе соревнования</p>
    </>
  )
};

export const getTextPlate = ({count, userType}: {count: number, userType: string}) => {
  const type = userType === 'municipality' || userType === 'citydistrict' ? 'муниципалитета' : 'региона';
  if (count === 0) {
    return withoutParticipants(type);
  }
  return withParticipants({count, type});
} 

